import { ChangeDetectorRef, Component } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { splitByProportion } from '@new-core/utils';

@Component({
    selector: 'ms-speed-reading-result-button, [ms-speed-reading-result-button]',
    templateUrl: './speed-reading-result-button.component.html',
    styleUrls: ['./speed-reading-result-button.component.scss'],
    hostDirectives: [DimensionsListenerDirective],
    standalone: false
})
export class SpeedReadingResultButtonComponent {
  parentStyles: Partial<CSSStyleDeclaration> = {};

  wrapperStyles: Partial<CSSStyleDeclaration> = {};

  contentStyles: Partial<CSSStyleDeclaration> = {};

  constructor(
    private readonly _dimensionsListener: DimensionsListenerDirective,
    private readonly _cdr: ChangeDetectorRef,
  ) {
    this._dimensionsListener.sizeChanges.subscribe((res) => {
      this.adjust(res.width, res.height);
    });
  }

  adjust(width: number, height: number) {
    this.wrapperStyles = {
      fontSize: height * 0.008 + 'px',
    };
    
    // const borderWidth = height * 0.2;
    // let [spread1, spread2, spread3] = splitByProportion(borderWidth, 10, 6, 8);
    // spread3 += spread2;
    // const shadowShift = spread3 * 5 / 7;
    // const [spreadColor1, spreadColor2, spreadColor3] = ['#f8e5be', '#f8e5be', '#4e3933'];
    // const paddingBottom = spread3 + shadowShift;
    // this.wrapperStyles = {
    //   // padding: `${spread3}px`,
    //   // paddingBottom: `${paddingBottom}px`,
    //   fontSize: height * 0.008 + 'px',
    // };
    // const contentHeight = height - spread3 - paddingBottom;
    // this.parentStyles = {
    //   // boxShadow: `0px 0px 0px ${spread2}px ${spreadColor2}, 0px 0px 0px ${spread3}px ${spreadColor3}, 0px ${shadowShift}px 0px ${spread3}px ${spreadColor3}`,
    //   // borderWidth: `${spread1}px`,
    //   // fontSize: `${contentHeight * 0.4}px`,
    //   // borderRadius: `${height * 0.2}px`,
    //   // fontSize: height * 0.01 + 'px',
    // };
    // // this.contentStyles = {
    // //   fontSize: `${contentHeight * 0.4}px`,
    // // };
    // // debugger;
    // this._cdr.markForCheck();
  }
}
